import CertificateNavTab from '../../../components/certificates/CertificateNavTab';
import CertificateNav from '../../../components/certificates/CertificateNav';
import { Navigate, Route, Routes } from 'react-router-dom';
import RequestTab from './RequestTab';


const OwnerPage = ({activeTab}) => {

    return (
        <>
            <CertificateNav activeTab={activeTab}>
                <CertificateNavTab eventKey='requests' to='/certificates/owner/requests' text='Requests' />
            </CertificateNav>

            <Routes>
                <Route path="/" element={<Navigate to="./requests" />} />
                <Route path="requests/:id?" element={<RequestTab />} />
            </Routes>
        </>
    );
};


export default OwnerPage;